import React from "react";
import CompanyService from "../services/company-service";
import { Table } from "components";
import {OrderedMap} from "immutable";
import { Button, Icon} from "antd";
import {List} from "immutable";
import moment from "moment/moment";
import {PROGRAM_TYPE_NEW} from "constants/enums";
import {TABLE_DATA_TYPES} from "../constants/table-data-types";

const MPA_APPROVAL_COLUMNS = (props) => new OrderedMap({
    anchor: {
        title: "Anchor Name",
        dataIndex: "company.name",
        key: "anchor"
    },
    gstin: {
        title: "Anchor Gstin",
        dataIndex: "company.gstin",
        key: "gstin"
    },
    industry: {
        title: "Industry",
        dataIndex: "industry.name",
        key: "industry"
    },
    program_type: {
        title: "Program Type",
        dataIndex: "program_type",
        key: "program_type",
        render : _ => PROGRAM_TYPE_NEW.get(_.toString()),
        dataType: TABLE_DATA_TYPES.SELECT,
        is_filter_applicable : true,
        options: [
            {
                label: "Primary",
                value: "1"
            },
            {
                label: "Secondary",
                value: "2"
            },
            {
                label: "PIF",
                value: "3"
            },
            {
                label: "CIF",
                value: "4"
            },
            {
                label: "Vendor Finance",
                value: "5"
            },
        ],
    },
    status: {
        title: "Status",
        dataIndex: "current_status",
        key: "current_status",
        dataType: TABLE_DATA_TYPES.SELECT,
        is_filter_applicable : true,
        options: [
            {
                label: "Awaiting Approval",
                value: "1"
            },
            {
                label: "Approved",
                value: "2"
            }
        ],
    },
    proposed_program_size: {
        title: "Proposed Program Size",
        dataIndex: "proposed_program_size_in_cr",
        key: "proposed_program_size_in_cr",
        render: _ => `${_} Cr.`,
    },
    requested_by: {
        title: "Requested By",
        dataIndex: "requested_by",
        key: "requested_by"
    },
    create_date: {
        title: "Requested Date",
        dataIndex: "create_date",
        key: "request_date",
        render: _ => _ && moment(_).format("DD/MM/YYYY"),
    },
    action: {
        title: "Action",
        key: "action",
        render: (_,item) =><Button type="link" onClick={() => props.history.push(`/app/companies/${item.company.id}`)}><Icon type="eye" /></Button> ,
    },
});

// import { CaseService, CompanyService } from "../../services";
class MPAApproval extends React.Component {
    state = {
        mpaApprovalData : List(),
        currentPage : 1,
        totalCount : 0,
        filterState : {}
    }
    pageSize = 20
    componentDidMount() {
        this.apiCall(1, this.pageSize);
    }


    apiCall = (page , pageSize , filter = {}) => {
        const finalFilter = Object.keys(filter).length ? filter : this.state.filterState;
        CompanyService.getMpaApprovalFilter(page, pageSize ,finalFilter).then(({data})=>{
            this.setState({
                totalCount : data["count"],
                mpaApprovalData : List(data["results"])
            });
        });
    }

     onPageChange = (page, page_size, filter) => {
         this.apiCall(page, page_size, filter);
         this.setState({currentPage: page});
     };

    onFilter=(filter)=>{
        this.setState({
            filterState: filter
        });
        this.apiCall(1 , this.pageSize, filter);
    }

    onPageSizeChange = (page, pageSize) => {
        this.pageSize = pageSize;
        this.apiCall(this.state.currentPage , pageSize);
    }

    render() {
        return(
            <React.Fragment>
                <Table
                    onFilter={this.onFilter}
                    data={this.state.mpaApprovalData}
                    columns={MPA_APPROVAL_COLUMNS(this.props)}
                    filterColumns={MPA_APPROVAL_COLUMNS(this.props).filter(_ => _.is_filter_applicable).map(_ => _.dataIndex).toList().toArray()}
                    showColumnSelector={false}
                    noRowSelection={true}
                    className={"inbox-table"}
                    pagination={{
                        current: this.state.currentPage,
                        showSizeChanger: true,
                        defaultPageSize: this.pageSize,
                        pageSizeOptions: [
                            "20",
                            "50",
                            "100",
                            "500"
                        ],
                        position: "bottom",
                        total: this.state.totalCount,
                        onChange: (page, pageSize) => this.onPageChange( page, pageSize),
                        onShowSizeChange: this.onPageSizeChange
                    }}
                />
            </React.Fragment>
        );
    }
}
export default MPAApproval;